// import {getVW, getVH} from "./utilities";

/**
 * One Single video player that plays all of the featured videos on the site.
 *
 * TODO: add close button to feature video player
 * TODO: add controls to feature video player
 * TODO: remove click anywhere to close
 */
let Schematic = function (params) {
  // console.log('Schematic initalizing ' + params);

  let self = this;

  let parentWrapper = document.getElementById('bp3-wrapper');
  let schematicElement = parentWrapper.querySelector('#schematic');
  let marker = schematicElement.querySelector('#marker');
  let pin = schematicElement.querySelector('#pin');
  let dot = schematicElement.querySelector('#dot');
  let gradient = parentWrapper.querySelector('#sections-gradient3');
  let isTweening = false;
  let positions = [
    { top: 163, left: 295 },   // section 1 - front door - 163, 295
    { top: 110, left: 80 },    // section 2 - mixing to molding - 110, 80
    { top: 110, left: 137 },   // section 3 - conditioning - 110, 137
    { top: 70, left: 135 },    // section 4 - extrusion - 70, 135
    { top: 60, left: 180 },    // section 5 - qa - 60, 180
    { top: 90, left: 145 },    // section 6 - core molding - 90, 145
    { top: 133, left: 218 },   // section 7 - dual core molding - 133, 218
    { top: 70, left: 240 },    // section 8 - operations - 70, 240
    { top: 90, left: 270 },    // section 9 - casing layer cover - 90, 270
    { top: 100, left: 270 },   // section 10 - casing layer molding - 100, 270
    { top: 43, left: 236 },    // section 11 - precision tooling - 43, 236
    { top: 15, left: 325 },    // section 12 - rd - 15, 325
    { top: 25, left: 260 },    // section 13 - casting - 25, 260
    { top: 48, left: 275 },    // section 14 - buffing - 48, 275
    { top: 56, left: 388 },    // section 15 - tumbling - 56, 388
    { top: 69, left: 330 },    // section 16 - primer paint - 69, 330
    { top: 94, left: 293 },    // section 17 - pad printing - 94, 293
    { top: 163, left: 295 },   // section 18 - front door - 163, 295
    { top: 163, left: 295 }    // section 19 - front door - 163, 295
  ];
  let slideTween, dotTween, pinTween, markerTween, gradientTween;

  self.killTweens = function () {
    // if( slideTween !== null && slideTween !== undefined) {
    //   slideTween.kill();
    // }
    if( dotTween !== null && dotTween !== undefined) {
      dotTween.kill();
    }
    if( pinTween !== null && pinTween !== undefined) {
      pinTween.kill();
    }
    if( markerTween !== null && markerTween !== undefined) {
      markerTween.kill();
    }
    if( gradientTween !== null && gradientTween !== undefined) {
      gradientTween.kill();
    }
  }

  self.show = function () {
    self.killTweens();
    self.hidePin();
    // console.log('show schematic');
    gsap.set([dot, pin], {opacity: 0});
    gradientTween = gsap.to(gradient, {opacity: 1, duration: 1, ease: 'power2.easein'});
    slideTween = gsap.fromTo(schematicElement, {x: 400, opacity: 0}, {x: 0, opacity: 1, duration: 0.75, onComplete: function () {
        self.dropPin();
      }});
  }

  self.hide = function () {
    self.killTweens();
    // console.log('hide schematic');
    gradientTween = gsap.to(gradient, {opacity: 0, duration: 0.5});
    slideTween = gsap.to(schematicElement, {x: 400, opacity: 0, duration: 0.5, onComplete: function () {
        self.hidePin();
      }});
  }

  self.hidePin = function () {
    gsap.set(marker, {top: positions[0].top, left: positions[0].left});
    gsap.set(pin, {opacity: 0, y: -50});
    gsap.set(dot, {opacity: 0, scale: 0});
  }

  self.removePin = function () {
    // console.log('remove pin ' + isTweening);
    self.killTweens();
    pinTween = gsap.to(pin, {opacity: 0, y: -50, duration: 0.3});
    dotTween = gsap.to(dot, {opacity: 0, scale: 0, duration: 0.3, delay: 0.15});
  }

  self.dropPin = function () {
    // console.log('drop pin ' + (window.bp3Application.currentSectionIndex - 1));
    self.killTweens();

    let index = window.bp3Application.currentSectionIndex - 1;
    if ( index < 0) {
      index = 0;
    }
    let position = positions[index];
    // gsap.set(marker, {top: position.top, left: position.left});
    // set in vw's instead
    // @function vw($pixels, $width: 1600) {
    //   @return calc(#{$pixels} / #{$width} * 100vw);
    // }
    // get vw equivalent at 1600 pixels
    marker.style.top = (position.top / 16).toString() + 'vw';
    marker.style.left = (position.left / 16).toString() + 'vw';


    dotTween = gsap.to(dot, {opacity: 0.6, scale: 1, duration: 0.8, ease: 'elastic.out(1, 0.25)'});
    dotTween = gsap.to(pin, {opacity: 0.7, y: 0, duration: 0.3, delay: 0.5});
  }


};

export default Schematic;

